export enum QuestionAnswerDataType {
  Integer = 'I',
  Text = 'T',
  Decimal = 'R'
}
